<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <section id="ngx-datatable-shipping">
            <div class="card">
                <div class="card-title d-flex justify-content-between align-items-center">
                    <h4>Vuelos</h4>
                    <button class="btn btn-primary" rippleEffect (click)="OpenCreateModal()">
                        <i data-feather="plus" class="mr-0 mr-sm-1"></i><span class="d-none d-sm-inline-block">Nuevo
                            Vuelo</span>
                    </button>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="d-flex justify-content-between align-items-center m-1">
                                <label class="d-flex align-items-center">Mostrando
                                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option *ngIf="flights.length > 15" [value]="flights.length">Todos</option>
                                    </select>
                                    vuelos</label>
                            </div>
                        </div>
                        <div class="col-md-6 col-12 d-flex justify-content-md-end">
                            <div class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0">
                                <label class="d-flex align-items-center">Buscar</label><input #searchInput type="search"
                                        placeholder="Codigo Vuelos" class="form-control ml-25 mb-1"
                                        (keyup)="FilterUpdate(searchInput.value)"
                                        (search)="FilterUpdate(searchInput.value)" />
                                        <button class="btn btn-success align-items-center ml-1 mb-1" type="button" (click)="export()" [disabled]="!flights?.length">
                                            <em class="fa fa-print"></em>
                                          </button>
                            </div>
                        </div>
                    </div>
                    
                    <ngx-datatable #table [rows]="flights" [rowHeight]="58" class="bootstrap core-bootstrap"
                        [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50" [scrollbarH]="true"
                        [limit]="basicSelectedOption"
                        [messages]="{emptyMessage: 'No hay información para mostrar', totalMessage: 'Total de vuelos'}">
                        <ngx-datatable-column name="Código" prop="code"></ngx-datatable-column>
                        <ngx-datatable-column name="Código del Envío" prop="shippingCode"></ngx-datatable-column>
                        <ngx-datatable-column name="Fecha del Vuelo" prop="flightDate">
                            <ng-template let-createAt="value" ngx-datatable-cell-template>
                                {{createAt | date: 'dd/MM/yyyy'}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Gastos" prop="totalCost">
                            <ng-template let-totalCost="value" ngx-datatable-cell-template>
                                {{totalCost | currency}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Estado" prop="isActive">
                            <ng-template let-isActive="value" ngx-datatable-cell-template>
                                <div class="badge badge-pill"
                                    [ngClass]="{
                                        'badge-light-primary': isActive === true,
                                        'badge-light-danger': isActive === false
                                    }">
                                    {{ isActive ? 'Abierto' : 'Cerrado' }}
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Acciones" [width]="200" [sortable]="false" prop="id">
                            <ng-template ngx-datatable-cell-template let-flightId="value">
                                <button class="btn btn-outline-light text-primary dropbtn" [ngbPopover]="popoverTemplate" #popOver="ngbPopover"
                                    data-container="body" placement="left-top" [autoClose]="'outside'" type="button" id="defaultDropdown"
                                    aria-expanded="false">
                                    <em class="fa fa-bars"></em>
                                </button>
                                <ng-template #popoverTemplate style="overflow: visible;">
                                    <div>
                                        <button type="button" ngbTooltip="Facturas" placement="left"
                                            class="btn btn-icon btn-outline-success text-success cursor-pointer mr-50" rippleEffect
                                            (click)="OpenBillsModal(flightId)">
                                            <span [data-feather]="'credit-card'"></span></button>
                                        <button type="button" ngbTooltip="Gastos" placement="left"
                                            class="btn btn-icon btn-outline-success text-success cursor-pointer mr-50" rippleEffect
                                            (click)="OpenExpensesModal(flightId)">
                                            <span [data-feather]="'file-text'"></span></button>
                                        <button type="button" ngbTooltip="Editar" placement="left"
                                            class="btn btn-icon btn-outline-info text-info cursor-pointer mr-50" rippleEffect
                                            (click)="OpenCreateModal(flightId)">
                                            <span [data-feather]="'edit'"></span></button>
                                        <button *ngIf="ShowDelete(flightId)" type="button" (click)="Delete(flightId)" ngbTooltip="Eliminar"
                                            placement="left" class="btn btn-icon btn-outline-danger text-danger cursor-pointer" rippleEffect>
                                            <span [data-feather]="'trash-2'"></span></button>
                                    </div>
                                </ng-template>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
                
            </div>
        </section>
    </div>
</div>